import React from "react";
import ContactsHeader from "./ContactsHeader";
import ContactPageForm from "./ContactPageForm";
import ContactPageMap from "./ContactPageMap";

const MainContacts = () => {
  return (
    <div style={{ backgroundColor: "#FFF4FA", marginTop: "100px" }}>
      <ContactPageForm />
      <ContactsHeader />
      <ContactPageMap />
    </div>
  );
};

export default MainContacts;
